











































import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
import { getDetail } from '../api';

Vue.use(Swipe)
  .use(ImagePreview)
  .use(SwipeItem)
  .use(Lazyload);

@Component
export default class Detail extends Vue {
  detailData: any = {};
  cover: any = [];

  async mounted() {
    // console.log('queryid:', this.$route.query.id);
    const retDetail: any = await getDetail(this.$route.query.id);
    this.detailData = retDetail.data;
    if (this.detailData.cover) {
      this.cover = this.detailData.cover.split('|');
    }
    const namelsit = retDetail.data.name.split('、');
    var namereturn = '';
    for (var i = 0; i < namelsit.length; i++) {
      namereturn = namereturn + '    ' + namelsit[i];
    }
    this.detailData.name = namereturn;
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
